import { render } from "./ModalPassengers.vue?vue&type=template&id=426492de"
import script from "./ModalPassengers.vue?vue&type=script&lang=js"
export * from "./ModalPassengers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__